import {
  ActionList,
  ActionListItem,
  ActionListItemIcon,
  Box,
  BoxIcon,
  ChevronDownIcon,
  Dropdown,
  DropdownButton,
  DropdownOverlay,
  Heading,
  MinusCircleIcon,
  PlusCircleIcon,
  UmbrellaIcon,
} from '@razorpay/blade/components';
import useIsFeatureDisabledForRearch from 'access/useIsFeatureDisabledForRearch';
import { routePaths } from 'components/Routes/data';
import React, { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';

const Header = (): ReactElement => {
  const history = useHistory();
  const { isNonPayableBenefitsDisabled } = useIsFeatureDisabledForRearch();
  const { isPerquisiteDisabled } = useIsFeatureDisabledForRearch();
  return (
    <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
      <Heading size="large">Salary Component Library</Heading>
      <Dropdown>
        <DropdownButton icon={ChevronDownIcon} iconPosition={'right'}>
          Create Component
        </DropdownButton>
        <DropdownOverlay>
          <ActionList>
            <ActionListItem
              leading={<ActionListItemIcon icon={PlusCircleIcon} />}
              onClick={({ name, value }) => {
                history.push(routePaths.salaryComponents.create.earnings.root);
              }}
              title="Earnings"
              value="earnings"
            />
            <ActionListItem
              leading={<ActionListItemIcon icon={MinusCircleIcon} />}
              onClick={({ name, value }) => {
                history.push(routePaths.salaryComponents.create.deductions.root);
              }}
              title="Deductions"
              value="deductions"
            />
            {!isNonPayableBenefitsDisabled && (
              <ActionListItem
                leading={<ActionListItemIcon icon={UmbrellaIcon} />}
                onClick={({ name, value }) => {
                  history.push(routePaths.salaryComponents.create.nonPayableBenefits.root);
                }}
                title="Non-Payable Benefit"
                value="non-payable-benefit"
              />
            )}
            {!isPerquisiteDisabled && (
              <ActionListItem
                leading={<ActionListItemIcon icon={BoxIcon} />}
                onClick={({ name, value }) => {
                  history.push(routePaths.salaryComponents.create.perquisites.root);
                }}
                title="Perquisites"
                value="perquisites"
              />
            )}
          </ActionList>
        </DropdownOverlay>
      </Dropdown>
    </Box>
  );
};

export default Header;
